import { useMutation } from "@tanstack/react-query";
import { superAdminControllerBackfillOrganizationBucketCors } from "../lib/gen-api";

export const useBackfillOrganizationBucketCorsData = () => {
  const { mutateAsync: backfillOrganizationBucketCors, isPending } =
    useMutation({
      mutationFn: async () => {
        const result =
          await superAdminControllerBackfillOrganizationBucketCors();
        if (!result.response.ok || !result.data) {
          throw new Error("Failed to backfill organization bucket CORS");
        }
        return result.data;
      },
    });

  return { backfillOrganizationBucketCors, isPending };
};
